import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  Role,
  RoleMetrics,
  Permission,
  UserSummary,
  CreateRoleRequest,
  UpdateRoleRequest,
  RolesListParams,
  AssignRoleRequest,
  AssignRoleResponse
} from '../types';

const { ROLES, PERMISSIONS, USERS } = API_ENDPOINTS;

export const rolesApi = {
  getAll: (params?: RolesListParams) =>
    apiClient.getPaginated<Role>(ROLES.LIST, params),

  getById: (id: number) => apiClient.get<Role>(ROLES.GET(id)),

  create: (data: CreateRoleRequest) => apiClient.post<Role>(ROLES.CREATE, data),

  update: (id: number, data: UpdateRoleRequest) =>
    apiClient.put<Role>(ROLES.UPDATE(id), data),

  delete: ({ id, force }: { id: number; force?: boolean }) =>
    apiClient.delete(ROLES.DELETE(id) + (force ? '?force=true' : '')),

  getMetrics: () => apiClient.get<RoleMetrics>(ROLES.METRICS),

  duplicate: (id: number) => apiClient.post<Role>(ROLES.DUPLICATE(id)),

  assignToUser: (userId: number, data: AssignRoleRequest) =>
    apiClient.post<AssignRoleResponse>(USERS.ASSIGN_ROLE(userId), data),

  bulkDelete: (
    params:
      | { ids: number[]; force?: boolean }
      | { all: true; filters: Partial<RolesListParams>; force?: boolean }
  ) => apiClient.post(ROLES.BULK_DELETE, params),

  bulkAssignPermissions: (
    params:
      | { ids: number[]; permissions: string[] }
      | { all: true; filters: Partial<RolesListParams>; permissions: string[] }
  ) => apiClient.post(ROLES.BULK_ASSIGN_PERMISSIONS, params)
};

export const permissionsApi = {
  getAll: () => apiClient.get<Permission[]>(PERMISSIONS.LIST)
};

export const usersApi = {
  getAll: (params?: { search?: string }) =>
    apiClient.get<UserSummary[]>(USERS.LIST, params)
};
